import apiHandler from '../../api/core/apiHandler';
import { CreateSpecialDocument, SpecialDocument } from '../../types/specialOperations/SpecialOperations';
import { SpecialDocumentCategory, SpecialOperationsPreview, SpecialOperationsRequest } from '../../types/specialOperations/SpecialOperations';
import { CustomResponse } from '../../types/api/CustomResponse';
import { FiscalEventSubmission } from '../../types/fiscal/FiscalEvent';

const simplifiedApi = apiHandler('dte/simplified-tickets');
const internalApi = apiHandler('dte/internal-control-receipts');
const reportApi = apiHandler('dte/sales/special-operations');
const saleDocumentApi = apiHandler('dte/sales');

const query = (branchId: number, from: string, to: string) =>
  `?branchId=${branchId}&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;

const SpecialOperationsService = {
  async listSimplified(branchId: number, from: string, to: string): Promise<SpecialDocument[]> {
    return (await simplifiedApi.fetchCustom(query(branchId, from, to))).data;
  },
  async listInternal(branchId: number, from: string, to: string): Promise<SpecialDocument[]> {
    return (await internalApi.fetchCustom(query(branchId, from, to))).data;
  },
  async createSimplified(data: CreateSpecialDocument): Promise<SpecialDocument> {
    return (await simplifiedApi.add(data)).data;
  },
  async createInternal(data: CreateSpecialDocument): Promise<SpecialDocument> {
    return (await internalApi.add(data)).data;
  },
  async voidDocument(category: SpecialDocumentCategory, id: number, reason: string): Promise<SpecialDocument> {
    const api = category === 'SIMPLIFIED_TICKET' ? simplifiedApi : internalApi;
    return (await api.addWithoutData(`/${id}/void?reason=${encodeURIComponent(reason)}`)).data;
  },
  async preview(request: SpecialOperationsRequest): Promise<CustomResponse<SpecialOperationsPreview>> {
    return (await reportApi.addCustom('/preview', request)).data;
  },
  async submit(request: SpecialOperationsRequest, idempotencyKey: string): Promise<CustomResponse<FiscalEventSubmission>> {
    return (await reportApi.addCustomWithHeaders(
      '?ambiente=00&idEnvio=1', request, { 'Idempotency-Key': idempotencyKey }
    )).data;
  },
  async prefillFromSale(saleId: number, category: SpecialDocumentCategory): Promise<CustomResponse<SpecialDocument>> {
    return (await saleDocumentApi.fetchCustom(
      `/${saleId}/special-operation-document/prefill?category=${category}`
    )).data;
  },
  async createFromSale(
    saleId: number,
    request: { category: SpecialDocumentCategory; description: string; documentoOrigen?: string | null }
  ): Promise<CustomResponse<SpecialDocument>> {
    return (await saleDocumentApi.addCustom(`/${saleId}/special-operation-document`, request)).data;
  },
};

export default SpecialOperationsService;
